// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home .clear-search {\n  display: block;\n  margin-top: 10px;\n  position: absolute;\n  left: 34%;\n  z-index: 1;\n}\n.home .clear-search.unclickable {\n  color: grey;\n  cursor: not-allowed;\n}\n.home .help-text {\n  font-size: 0.8em;\n  font-weight: 400;\n  font-style: normal;\n  color: #b4b2b2;\n}\n", ""]);
// Exports
module.exports = exports;
